export const StockStoreTypeEnum = ['REAL']
export const StockStoreTypeMap = {
  [StockStoreTypeEnum[0]]: '仓库库存',
  [StockStoreTypeEnum[1]]: '线上销售库存'
}

export const checkBillStatusMap = {
  1001: '盘点中',
  2001: '已完成'
}

export const inventoryTypeEnum = {
  IN: 'IN',
  OUT: 'OUT'
}
export const inventoryTypeMap = {
  IN: '入库',
  OUT: '出库'
}
export const typeMap = {
  PURCHAGE_OK: {
    tips: ['成本价', '当前进货成本价'],
    name: '采购入库',
    amountTitle: '采购成本总额',
    type: inventoryTypeEnum.IN
  },
  SALE_CANCEL: {
    tips: ['成本价', '移动平均价'],
    name: '退货入库',
    amountTitle: '成本总额',
    type: inventoryTypeEnum.IN
  },
  CHECK_MORE: {
    tips: ['成本价', '移动平均价'],
    name: '盘盈入库',
    amountTitle: '成本总额',
    type: inventoryTypeEnum.IN
  },
  ALLOCATION_IN: {
    tips: ['成本价', '移动平均价'],
    name: '调拨入库',
    amountTitle: '调入金额(元)',
    type: inventoryTypeEnum.IN
  },
  PURCHAGE_CANCEL: {
    tips: ['参考成本价', '默认取最近一次采购成本价'],
    name: '采购退货',
    amountTitle: '退款总额',
    type: inventoryTypeEnum.OUT
  },
  SALE_OK: {
    tips: ['成本价（元）', '移动平均价'],
    name: '销售出库',
    amountTitle: '成本总额',
    type: inventoryTypeEnum.OUT
  },
  CHECK_LESS: {
    tips: ['成本价（元）', '移动平均价'],
    name: '盘亏出库',
    amountTitle: '成本总额',
    type: inventoryTypeEnum.OUT
  },
  ALLOCATION_OUT: {
    tips: ['成本价（元）', '移动平均价'],
    name: '调拨出库',
    amountTitle: '调出金额(元)',
    type: inventoryTypeEnum.OUT
  },
}
export const wayTypeMap = {
  AUTO_IN: '自动入库',
  AUTO_OUT: '自动出库',
  COUNT_IN: '数量入库',
  COUNT_OUT: '数量出库'
}

export const statusMap = {
  DISCARD: '已作废',
  FINISHED: '已完成'
}

export const transfersOutStatusMap = {
  NOT_START: '待调拨',
  ON_THE_WAY: '调拨中',
  FINISHED: '已完成',
  CANCEL: '已取消'
}

export const transfersInStatusMap = {
  ON_THE_WAY: '调拨中',
  FINISHED: '已完成',
  CANCEL: '已取消'
}

export const typeList = Object.keys(typeMap).map(item => {
  return {
    value: item,
    inventoryType: typeMap[item].type,
    title: typeMap[item].name
  }
})

export const inventoryType = Object.keys(inventoryTypeMap).reduce(
  (re, item) => {
    return Object.assign({}, re, {
      [inventoryTypeEnum[item]]: {
        name: inventoryTypeMap[item],
        list: typeList.filter(typeItem => typeItem.inventoryType === item),
        typeMap: typeList.reduce((or, typeItem) => {
          let before = (or && or[item]) || {}
          return Object.assign({}, or, {
            [item]: { ...before, [typeItem.value]: typeMap[typeItem.value] }
          })
        }, null),
        wayTypeMap: Object.keys(wayTypeMap)
          .filter(way => way.indexOf(item) > -1)
          .reduce(
            (wayMap, way) =>
              Object.assign({}, wayMap, { [way]: wayTypeMap[way] }),
            {}
          )
      }
    })
  },
  {}
)
